import useAsyncData from "../../../../hooks/use-async-data";
import cargoCompanyService from "../../cargo-company.service";
import CargoCompanyOrderBillingsList from "./cargo-company-order-billings-list";
import CargoCompanyOrderBillingsListParams from "./cargo-company-order-billings-list-params";

const useCargoCompanyOrderBillingsList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<CargoCompanyOrderBillingsList>({
      data: [],
      totalCount: 0,
    });

  const load = async (
    params: CargoCompanyOrderBillingsListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoCompanyOrderBillingsListing =
        await cargoCompanyService.getCargoOrderBillingsList(params, signal);

      setData(cargoCompanyOrderBillingsListing);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useCargoCompanyOrderBillingsList;
